import {
    Box,
    Button,
    Divider,
    Grid,
    IconButton,
    MenuItem,
    Select,
    TextField,
    Typography,
  } from "@mui/material";
  import React, { useEffect, useState } from "react";
  import { ErrorMessage, Field, Form, Formik } from "formik";
  import * as Yup from "yup";
  import { Clear } from "@mui/icons-material";
import { masterAPI } from "../../../Masters/dataConfig";
import { color } from "../../../../StyleData/Config";
import { axiosPrivate } from "../../../../axios/axios";
import { toast } from "react-toastify";
import ErrorProps from "../../../../Component/Errorprops";

  


  
  const StockRoomModal = ({ mode, handleCloseClick, editData }) => {
   
    const [loading,setLoading]=useState(false)
  
    const validationSchema = Yup.object({
      code: Yup.string().required("Stock Room Code is required"),
      stockRoomName: Yup.string().required("Stock Room Name is required"),
      stockRoomDesc: Yup.string()
    });

    const initialValue = {
      stockRoomName: mode === "Edit" ? editData.stockRoomName : "",
      stockRoomDesc: mode === "Edit" ? editData.stockRoomDesc : "",
      code: mode === "Edit" ? editData.code : ""
      // aisle: mode === "Edit" ? editData.aisle : "",
      // rowName: mode === "Edit" ? editData.rowName : "",
      // binNo: mode === "Edit" ? editData.binNo : "",
      // quantityOnHand: mode === "Edit" ? editData.quantityOnHand : "",
    };
  
    const onSubmit = async(value) => {
      console.log(value);
      setLoading(true)
      const createLink = masterAPI["stockRoom"].create;
      const updateLink = masterAPI["stockRoom"].update;
      if (mode === "Create") {
          
       await axiosPrivate
          .post(`${createLink}`, value)
          .then((res) => {
            console.log(res.data);
            setLoading(false)
            handleCloseClick();
          })
          .catch((e) => {
            setLoading(false)
            if(e.response && e.response.data && e.response.data.failureMessage) {
              toast.error(e.response.data.failureMessage);
            } else {
              toast.error("Failed to create stock room. Please try again.");
            }
            console.log(e, "create stockRoom");
          });
      } else {
        const updateAC = {
          id: editData.id,
          ...value,
        };
       await axiosPrivate
          .put(`${updateLink}`, updateAC)
          .then((res) => {
            console.log(res.data);
            setLoading(false)
            handleCloseClick();
          })
          .catch((e) => {
            setLoading(false)
            if(e.response && e.response.data && e.response.data.failureMessage) {
              toast.error(e.response.data.failureMessage);
            } else {
              toast.error("Failed to update stock room. Please try again.");
            }
            console.log(e, "update stockRoom");
          });
      }
    };
  
    const handleCancel = () => {
      handleCloseClick();
    };
  
    return (
      <Box sx={{ p: color.masterPageDialogPadding }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Typography
            sx={{
              color: color.masterDialogTitleColor,
              fontSize: color.masterDialogFontSize,
            }}
          >
            {mode==="Edit"?editData.code+" - "+editData.stockRoomName:"New Stock Room"}
          </Typography>
          <IconButton onClick={handleCancel}>
            <Clear />
          </IconButton>
        </Box>
        <Divider sx={{border:"1px solid rgb(0 0 0 / 17%)",mb:"15px"}} />
        <Formik initialValues={initialValue} validationSchema={validationSchema} onSubmit={onSubmit}>
          {({ handleChange, setFieldValue, values, resetForm }) => (
            <Form>
              <Grid container spacing={"1rem"}>
              <Grid item xs={12} md={6} >
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Stock Room Code <span style={{ color: "red" }}>*</span>
                </Typography>
                  <Field
                    as={TextField}
                    size={"small"}
                    type="text"
                    name="code"
                    placeholder="Enter Stock Room Code"
                    fullWidth
                    sx={{
                      ".MuiInputBase-input": {
                        // letterSpacing: "0.2rem",
  
                        "&::placeholder": {
                          // color: "green",
                          opacity: 1,
                          color: color.placeholderColor,
                          fontSize: "13px",
                        },
                      },
                    }}
                  />
                  <ErrorMessage name="code">
                    {(error) => <ErrorProps>{error}</ErrorProps>}
                  </ErrorMessage>
                </Grid>
                <Grid item xs={12} md={6} >
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Stock Room Name <span style={{ color: "red" }}>*</span>
                </Typography>
                  <Field
                    as={TextField}
                    size={"small"}
                    type="text"
                    name="stockRoomName"
                    placeholder="Enter Stock Room Name"
                    fullWidth
                    sx={{
                      ".MuiInputBase-input": {
                        // letterSpacing: "0.2rem",
  
                        "&::placeholder": {
                          // color: "green",
                          opacity: 1,
                          color: color.placeholderColor,
                          fontSize: "13px",
                        },
                      },
                    }}
                  />
                  <ErrorMessage name="stockRoomName">
                    {(error) => <ErrorProps>{error}</ErrorProps>}
                  </ErrorMessage>
                </Grid>

                <Grid item xs={12} md={6} >
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Stock Room Description
                </Typography>
                  <Field
                    as={TextField}
                    size={"small"}
                    type="text"
                    name="stockRoomDesc"
                    placeholder="Enter Stock Room Desc"
                    fullWidth
                    sx={{
                      ".MuiInputBase-input": {
                        // letterSpacing: "0.2rem",
  
                        "&::placeholder": {
                          // color: "green",
                          opacity: 1,
                          color: color.placeholderColor,
                          fontSize: "13px",
                        },
                      },
                    }}
                  />
                </Grid>
     
                <Grid
                  container
                  item
                  xs={12}
                  justifyContent={"flex-end"}
                  gap="1rem"
                >
                  <Button
                    onClick={handleCancel}
                    variant="contained"
                    sx={{
                      backgroundColor: color.TableCancelButton,
                      textTransform: "none",
                      color: color.CancelTextColor,
                      ":hover": {
                        backgroundColor: color.TableCancelButton,
                        textTransform: "none",
                        color: color.CancelTextColor,
                      },
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    type={"submit"}
                    variant="contained"
                    disabled={loading}
                    sx={{
                      
                      textTransform: "none",
                      backgroundColor: loading ? "default" : color.TableButtonColor,
                      "&:hover": {
                        backgroundColor: loading
                          ? "default"
                          : color.buttonDisable,
                      },
                    }}
                  >
                    Submit
                  </Button>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </Box>
    );
  };
  
  export default StockRoomModal;
  